import { connect } from 'react-redux'
import Tabs from "./Tabs";

const mapStateToProps = (state, ownProps) => {
  return {
    nbQuestions: state.exam.questions.length,
    currentQuestion: state.exam.currentQuestion || 0
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const TabsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Tabs);

export default TabsContainer
